import { ReactNode } from "react";
import {
  useForm,
  UseFormReturn,
  FieldValues,
  Resolver,
  DefaultValues,
  SubmitHandler,
} from "react-hook-form";

export default function Form<FormValues extends FieldValues>({
  defaultValues,
  children,
  onSubmit,
  resolver,
  formId = "hook-form",
}: {
  children: (methods: UseFormReturn<FormValues>) => ReactNode;
  onSubmit: SubmitHandler<FormValues>;
  defaultValues?: DefaultValues<FormValues>;
  resolver: Resolver<FormValues>;
  formId?: string;
}) {
  const methods = useForm<FormValues>({ defaultValues, resolver });
  const { handleSubmit } = methods;

  return (
    <form id={formId} onSubmit={handleSubmit(onSubmit)}>
      {children(methods)}
    </form>
  );
}
